import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { Link, useNavigate } from "react-router-dom";
import {
  closeModal,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../master/Master";

import { courseList } from "../../../api/Courses";
import DownloadExcel from "../../master/DownloadExcel";
import Swal from "sweetalert2";

import {
  CallingData,
  CreateMarketingFollowStudent,
  CreateMarketingStudent,
  followupDataPost,
  GetMarketingSchool,
  GetMarketingSource,
} from "../../../api/MarketinService";

import { counselor } from "../../../api/Calling";
import { getSessions } from "../../../api/SessionsService";

import {
  BlockFetch,
  DistrictFetch,
  StateFetch,
} from "../../../api/LocationService";

import MarketingHeader from "../Marketings/MarketingHeader";

/* ============================================================
   EMPTY STATE
============================================================ */

const EmptyState = ({ message = "No data found" }) => {
  return (
    <div className="py-5 text-center">
      <div
        className="mx-auto mb-3 rounded-circle bg-label-primary d-flex align-items-center justify-content-center"
        style={{
          width: "70px",
          height: "70px",
        }}
      >
        <i className="ri ri-inbox-line fs-2 text-primary"></i>
      </div>

      <h6 className="fw-bold mb-1">{message}</h6>

      <p className="text-muted mb-0 small">
        Try changing your search or counselor selection.
      </p>
    </div>
  );
};

/* ============================================================
   COUNSELOR CALL
============================================================ */

const CounselorCall = () => {
  const hasAccess = usePrivateLink();

  const [data, setdata] = useState([]);
  const [course, setcourse] = useState([]);
  const [status, setStatus] = useState("");
  const [enquiry, setEnquiry] = useState([]);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("marketing");

  const [counse, setcounse] = useState([]);
  const [selectedCounselor, setSelectedCounselor] = useState();

  const [modatData, setModalData] = useState("");
  const [selectData, setSelectData] = useState("");

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const userId = userData?.id;
  const userType = userData?.staff?.type_id;

  const [address, setAddress] = useState(false);

  const handleToggle = () => {
    setAddress((prev) => !prev);
  };

  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allBlock, setAllBlock] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [subjects, setSubjects] = useState("");
  const [session, setSession] = useState("");

  const [source, setSource] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  /* ============================================================
     COURSE FETCH
  ============================================================ */

  const courseFetch = async () => {
    setLoading(true);

    try {
      const response = await courseList();

      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
  }, []);

  /* ============================================================
     SOURCE FETCH
  ============================================================ */

  const getSource = async () => {
    setLoading(true);

    try {
      const response = await GetMarketingSource();

      if (response?.data) {
        setSource(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     CREATE STUDENT
  ============================================================ */

  const createStudent = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await CreateMarketingFollowStudent(formData);

      if (response.data?.status) {
        closeModal("addStudentModal");

        ToastMain.fire({
          icon: "success",
          title: "created successfully!",
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.message ??
          error?.response?.data?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     SESSION
  ============================================================ */

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions();

      if (response.data.status) {
        console.log("session fetched", response.data);

        setSession(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     STATE
  ============================================================ */

  const getState = async () => {
    setLoading(true);

    try {
      const response = await StateFetch();

      if (response.data) {
        setAllStates(response?.data?.states);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     DISTRICT
  ============================================================ */

  const getdistrict = async (state) => {
    setLoading(true);

    try {
      const response = await DistrictFetch(state);

      if (response.data) {
        setAllDistricts(response?.data?.districts);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     BLOCK
  ============================================================ */

  const getblock = async (district) => {
    setLoading(true);

    try {
      const response = await BlockFetch(district);

      if (response?.data) {
        setAllBlock(response?.data?.blocks);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     SCHOOL
  ============================================================ */

  const fetchSchool = async () => {
    setLoading(true);

    try {
      const response = await GetMarketingSchool();

      if (response.data) {
        setSchool(response?.data);
      } else {
        setError("Failed to fetch courses.");

        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.data?.message ?? err?.message);
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     INITIAL DATA
  ============================================================ */

  useEffect(() => {
    getState();
    getSession();
    fetchSchool();
    getSource();
  }, []);

  /* ============================================================
     CREATE RESPONSE
  ============================================================ */

  const CreateResponse = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const form = e.target;

      const formData = new FormData(form);

      formData.append("counselor_id", selectedCounselor);

      formData.append("type", type);

      const response = await followupDataPost(formData);

      if (response.data.status) {
        setError("");

        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Submitted successfully!",
        }).then(() => {
          closeModal("followupModal");

          GetData();

          form.reset();
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     COUNSELOR
  ============================================================ */

  const getcounselor = async () => {
    setLoading(true);

    try {
      const response = await counselor();

      console.log("Source List:", response.data);

      if (response?.data) {
        setcounse(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      console.error("API Error:", error);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /*
   * Kept exactly as your original logic
   */
  useEffect(() => {
    getcounselor();
  }, [selectedCounselor]);

  /* ============================================================
     GET DATA
  ============================================================ */

  const GetData = async () => {
    setLoading(true);

    const addUrl =
      `&type=${type}` +
      `&counselor_id=${selectedCounselor}` +
      `&search=${search}` +
      `&per_page=${selectData}`;

    try {
      const response = await CallingData(addUrl);

      if (response.data) {
        setdata(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     DATA EFFECT
  ============================================================ */

  useEffect(() => {
    if (type) {
      GetData();
    }
  }, [type, search, selectData, selectedCounselor]);

  /* ============================================================
     STATUS CHANGE
  ============================================================ */

  const handleStatusChange = (newType, newStatus) => {
    setType(newType);
    setStatus(newStatus);
  };

  /* ============================================================
     DOWNLOAD
  ============================================================ */

  const handleDownload = () => {
    const exportData = enquiry?.data || [];

    if (exportData.length === 0) {
      alert("No data available to export");

      return;
    }

    DownloadExcel(
      exportData,
      ["SN", "Student Name", "response", "followup_date"],
      "Enquiry List",
      [
        {
          type: "rename",
          oldKey: "student_name",
          newKey: "Student Name",
        },
        {
          type: "rename",
          oldKey: "father_name",
          newKey: "Father Name",
        },
        {
          type: "add",
          newKey: "Time",
          value: "00:00:00",
        },
      ],
    );
  };

  /* ============================================================
     RENDER
  ============================================================ */

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                {/* ==================================================
                    MARKETING HEADER
                ================================================== */}

                <MarketingHeader />

                {/* ==================================================
                    PAGE HEADER
                ================================================== */}

                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white"
                          style={{
                            width: "52px",
                            height: "52px",
                            minWidth: "52px",
                          }}
                        >
                          <i className="ri ri-phone-fill fs-4"></i>
                        </div>

                        <div>
                          <h4 className="mb-1 fw-bold">Counselor Call</h4>

                          <p className="text-muted mb-0">
                            Manage counselor leads, calls and follow-ups
                          </p>
                        </div>
                      </div>

                      {hasAccess("/Counselor Call/student/add") &&
                        selectedCounselor && (
                          <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center gap-2 px-4"
                            data-bs-target="#addStudentModal"
                            data-bs-toggle="modal"
                            onClick={() => setError("")}
                          >
                            <i className="ri ri-user-add-line"></i>
                            Add Student
                          </button>
                        )}
                    </div>
                  </div>
                </div>

                {/* ==================================================
                    FILTER CARD
                ================================================== */}

                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-header bg-transparent border-0 pb-0">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                        style={{
                          width: "36px",
                          height: "36px",
                        }}
                      >
                        <i className="ri ri-filter-3-line text-primary"></i>
                      </div>

                      <div>
                        <h6 className="mb-0 fw-bold">Search & Filters</h6>

                        <small className="text-muted">
                          Select counselor and search student records
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row g-3 align-items-end">
                      {/* COUNSELOR */}

                      <div className="col-lg-4 col-md-6">
                        <label className="form-label fw-semibold">
                          Select Counselor
                        </label>

                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri ri-user-star-line text-primary"></i>
                          </span>

                          <select
                            name="counselor_id"
                            className="form-select"
                            value={selectedCounselor || ""}
                            onChange={(e) =>
                              setSelectedCounselor(e.target.value)
                            }
                            defaultValue=""
                          >
                            <option value="" disabled>
                              -- Select Counselor --
                            </option>

                            {counse?.data
                              ?.filter((counselor) => {
                                if (
                                  counselor?.user?.id === userId &&
                                  counselor?.type_id === userType
                                ) {
                                  return true;
                                }

                                const hasMatch = counse?.data?.some(
                                  (c) =>
                                    c?.user?.id === userId &&
                                    c?.type_id === userType,
                                );

                                return !hasMatch;
                              })
                              ?.map((counselor, index) => (
                                <option key={index} value={counselor.id}>
                                  {counselor.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* SEARCH */}

                      {selectedCounselor && (
                        <>
                          <div className="col-lg-5 col-md-6">
                            <label className="form-label fw-semibold">
                              Search Student
                            </label>

                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri ri-search-line text-primary"></i>
                              </span>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Name, Mobile"
                                name="search"
                                value={search}
                                onChange={(e) => {
                                  e.target.value = e.target.value.toUpperCase();

                                  setSearch(e.target.value);
                                }}
                              />

                              {search && (
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  onClick={() => setSearch("")}
                                >
                                  <i className="ri ri-close-line"></i>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* RECORD COUNT */}

                          <div className="col-lg-3 col-md-12">
                            <label className="form-label fw-semibold">
                              Records per page
                            </label>

                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri ri-list-check-2 text-primary"></i>
                              </span>

                              <select
                                name="per_page"
                                value={selectData}
                                onChange={(e) => setSelectData(e.target.value)}
                                className="form-select"
                              >
                                <option value="100">100</option>

                                <option value="300">300</option>

                                <option value="500">500</option>

                                <option value="1000">1000</option>

                                <option value="1500">1500</option>

                                <option value="2000">2000</option>
                              </select>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* ==================================================
                    SELECT COUNSELOR EMPTY STATE
                ================================================== */}

                {!selectedCounselor && (
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <div className="py-5 text-center">
                        <div
                          className="rounded-circle bg-label-primary mx-auto mb-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "75px",
                            height: "75px",
                          }}
                        >
                          <i className="ri ri-user-search-line fs-2 text-primary"></i>
                        </div>

                        <h5 className="fw-bold mb-2">Select a Counselor</h5>

                        <p className="text-muted mb-0">
                          Select a counselor above to view their student call
                          records.
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* ==================================================
                    TABLE
                ================================================== */}

                {selectedCounselor && type && (
                  <div className="card border-0 shadow-sm">
                    {/* TABLE HEADER */}

                    <div className="card-header bg-transparent border-0">
                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                            style={{
                              width: "40px",
                              height: "40px",
                            }}
                          >
                            <i className="ri ri-user-follow-line fs-5 text-primary"></i>
                          </div>

                          <div>
                            <h5 className="mb-1 fw-bold">Counselor Leads</h5>

                            <div className="d-flex align-items-center gap-2">
                              <span className="badge bg-label-primary text-primary">
                                Total Students {data?.data?.length || 0}
                              </span>

                              {search && (
                                <span className="text-muted small">
                                  <i className="ri ri-search-line me-1"></i>

                                  {search}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted small">Lead Type</span>

                          <span className="badge bg-label-primary text-primary text-capitalize px-3 py-2">
                            {type}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* TABLE */}

                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          {/* =================================================
                              ENQUIRY HEADER
                          ================================================= */}

                          {type === "enquiry" && (
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "60px",
                                  }}
                                >
                                  #
                                </th>

                                <th>Student</th>

                                <th>Father Name</th>

                                <th>Mobile</th>

                                <th>Address</th>

                                <th>Course</th>

                                <th>Status</th>

                                <th>Date</th>
                              </tr>
                            </thead>
                          )}

                          {/* =================================================
                              FEES HEADER
                          ================================================= */}

                          {type === "fees" && (
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "60px",
                                  }}
                                >
                                  #
                                </th>

                                <th>Student</th>

                                <th>Father Name</th>

                                <th>Mobile</th>

                                <th>Address</th>

                                <th>Course</th>

                                <th>Batch</th>

                                <th>Date</th>
                              </tr>
                            </thead>
                          )}

                          {/* =================================================
                              MARKETING HEADER
                          ================================================= */}

                          {type === "marketing" && (
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "60px",
                                  }}
                                >
                                  #
                                </th>

                                <th>Student</th>

                                <th>Father Name</th>

                                <th>Mobile</th>

                                <th>Source</th>

                                <th>Address</th>

                                <th>Date</th>
                              </tr>
                            </thead>
                          )}

                          {/* =================================================
                              ENQUIRY BODY
                          ================================================= */}

                          {type === "enquiry" && (
                            <tbody>
                              {data?.data?.length === 0 ? (
                                <tr>
                                  <td colSpan="8">
                                    <EmptyState message="No enquiry records found" />
                                  </td>
                                </tr>
                              ) : (
                                data?.data?.map((item, i) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    data-bs-target="#followupModal"
                                    data-bs-toggle="modal"
                                    onClick={() => setModalData(item.id)}
                                  >
                                    <td className="text-muted fw-semibold">
                                      {i + 1}
                                    </td>

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle bg-label-primary text-primary fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                          style={{
                                            width: "38px",
                                            height: "38px",
                                          }}
                                        >
                                          {(item?.student_name || "NA")
                                            .split(" ")
                                            .slice(0, 2)
                                            .map((word) => word?.[0])
                                            .join("")
                                            .toUpperCase()}
                                        </div>

                                        <div>
                                          <div className="fw-semibold text-capitalize">
                                            {item?.student_name || "N/A"}
                                          </div>

                                          <small className="text-muted">
                                            ID: {item?.id}
                                          </small>
                                        </div>
                                      </div>
                                    </td>

                                    <td className="text-capitalize">
                                      {item?.father_name || "N/A"}
                                    </td>

                                    <td>
                                      <a
                                        href={`tel:${item?.mobile}`}
                                        onClick={(e) => e.stopPropagation()}
                                        className="text-decoration-none"
                                      >
                                        <i className="ri ri-phone-line text-success me-1"></i>

                                        {item?.mobile || "N/A"}
                                      </a>
                                    </td>

                                    <td>
                                      <span
                                        className="text-muted text-truncate d-inline-block"
                                        style={{
                                          maxWidth: "160px",
                                        }}
                                        title={item?.village}
                                      >
                                        <i className="ri ri-map-pin-line me-1"></i>

                                        {item?.village || "N/A"}
                                      </span>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-primary text-primary">
                                        <i className="ri ri-book-open-line me-1"></i>

                                        {item?.course?.title || "N/A"}
                                      </span>
                                    </td>

                                    <td>
                                      <span
                                        className={`badge ${
                                          item?.status === "hot"
                                            ? "bg-label-danger text-danger"
                                            : item?.status === "follow_up"
                                              ? "bg-label-warning text-warning"
                                              : "bg-label-secondary text-secondary"
                                        }`}
                                      >
                                        {item?.status || "N/A"}
                                      </span>
                                    </td>

                                    <td className="text-nowrap">
                                      <i className="ri ri-calendar-line text-muted me-1"></i>

                                      {item?.enquiry_date || "N/A"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          )}

                          {/* =================================================
                              FEES BODY
                          ================================================= */}

                          {type === "fees" && (
                            <tbody>
                              {data?.data?.length === 0 ? (
                                <tr>
                                  <td colSpan="8">
                                    <EmptyState message="No fee records found" />
                                  </td>
                                </tr>
                              ) : (
                                data?.data?.map((item, i) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    data-bs-target="#followupModal"
                                    data-bs-toggle="modal"
                                    onClick={() => setModalData(item.id)}
                                  >
                                    <td className="text-muted fw-semibold">
                                      {i + 1}
                                    </td>

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle bg-label-primary text-primary fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                          style={{
                                            width: "38px",
                                            height: "38px",
                                          }}
                                        >
                                          {(item?.student_info?.name || "NA")
                                            .split(" ")
                                            .slice(0, 2)
                                            .map((word) => word?.[0])
                                            .join("")
                                            .toUpperCase()}
                                        </div>

                                        <div>
                                          <div className="fw-semibold text-capitalize">
                                            {item?.student_info?.name || "N/A"}
                                          </div>

                                          <small className="text-muted">
                                            ID: {item?.id}
                                          </small>
                                        </div>
                                      </div>
                                    </td>

                                    <td className="text-capitalize">
                                      {item?.student_info?.father_name || "N/A"}
                                    </td>

                                    <td>
                                      <a
                                        href={`tel:${item?.student_info?.phone}`}
                                        onClick={(e) => e.stopPropagation()}
                                        className="text-decoration-none"
                                      >
                                        <i className="ri ri-phone-line text-success me-1"></i>

                                        {item?.student_info?.phone || "N/A"}
                                      </a>
                                    </td>

                                    <td>
                                      <span
                                        className="text-muted text-truncate d-inline-block"
                                        style={{
                                          maxWidth: "160px",
                                        }}
                                      >
                                        <i className="ri ri-map-pin-line me-1"></i>

                                        {item?.student_info?.village || "N/A"}
                                      </span>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-primary text-primary">
                                        <i className="ri ri-book-open-line me-1"></i>

                                        {item?.course?.title || "N/A"}
                                      </span>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-info text-info">
                                        {item?.batch?.title || "N/A"}
                                      </span>
                                    </td>

                                    <td className="text-nowrap">
                                      <i className="ri ri-calendar-line text-muted me-1"></i>

                                      {item?.student_info?.admission_date ||
                                        "N/A"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          )}

                          {/* =================================================
                              MARKETING BODY
                          ================================================= */}

                          {type === "marketing" && (
                            <tbody>
                              {data?.data?.length === 0 ? (
                                <tr>
                                  <td colSpan="7">
                                    <EmptyState message="No marketing leads found" />
                                  </td>
                                </tr>
                              ) : (
                                data?.data?.map((item, i) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    data-bs-target="#followupModal"
                                    data-bs-toggle="modal"
                                    onClick={() => setModalData(item.id)}
                                  >
                                    <td className="text-muted fw-semibold">
                                      {i + 1}
                                    </td>

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle bg-label-primary text-primary fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                          style={{
                                            width: "38px",
                                            height: "38px",
                                          }}
                                        >
                                          {(item?.name || "NA")
                                            .split(" ")
                                            .slice(0, 2)
                                            .map((word) => word?.[0])
                                            .join("")
                                            .toUpperCase()}
                                        </div>

                                        <div>
                                          <div className="fw-semibold text-capitalize">
                                            {item?.name || "N/A"}
                                          </div>

                                          <small className="text-muted">
                                            ID: {item?.id}
                                          </small>
                                        </div>
                                      </div>
                                    </td>

                                    <td className="text-capitalize">
                                      {item?.fathers_name || "N/A"}
                                    </td>

                                    <td>
                                      <a
                                        href={`tel:${item?.mobile}`}
                                        onClick={(e) => e.stopPropagation()}
                                        className="text-decoration-none"
                                      >
                                        <i className="ri ri-phone-line text-success me-1"></i>

                                        {item?.mobile || "N/A"}
                                      </a>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-primary text-primary">
                                        <i className="ri ri-megaphone-line me-1"></i>

                                        {item?.source?.source_name || "N/A"}
                                      </span>
                                    </td>

                                    <td>
                                      <span
                                        className="text-muted text-truncate d-inline-block"
                                        style={{
                                          maxWidth: "180px",
                                        }}
                                        title={item?.address}
                                      >
                                        <i className="ri ri-map-pin-line me-1"></i>

                                        {item?.address || "N/A"}
                                      </span>
                                    </td>

                                    <td className="text-nowrap">
                                      <i className="ri ri-calendar-line text-muted me-1"></i>

                                      {item?.created_at
                                        ? new Date(
                                            item.created_at,
                                          ).toLocaleDateString("en-IN", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          })
                                        : "N/A"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>

                      {/* TABLE FOOTER */}

                      {data?.data?.length > 0 && (
                        <div className="border-top mt-3 pt-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
                          <small className="text-muted">
                            Showing <strong>{data?.data?.length}</strong>{" "}
                            records
                          </small>

                          <small className="text-muted">
                            <i className="ri ri-information-line me-1"></i>
                            Click a student row to submit a follow-up
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================================================================
          FOLLOW-UP MODAL
      ================================================================= */}

      <div
        className="modal fade"
        id="followupModal"
        tabIndex={-1}
        aria-labelledby="followupModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow">
            {/* HEADER */}

            <div className="modal-header border-0 px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                  style={{
                    width: "44px",
                    height: "44px",
                  }}
                >
                  <i className="ri ri-phone-add-line fs-5 text-primary"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-1"
                    id="followupModalLabel"
                  >
                    Submit{" "}
                    <span className="text-primary">{type?.toUpperCase()}</span>{" "}
                    Response
                  </h5>

                  <small className="text-muted">
                    Record the latest conversation with this student
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* BODY */}

            <div className="modal-body px-4 pb-4">
              <form id="followupForm" onSubmit={CreateResponse}>
                <input type="hidden" name="user_id" value={modatData} />

                {/* STATUS */}

                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Response Status
                  </label>

                  <div className="row g-2">
                    <div className="col-md-4">
                      <label
                        htmlFor="notInterested"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="notInterested"
                          name="status"
                          value="not_interested"
                          className="form-check-input mt-0"
                          required
                        />

                        <div>
                          <div className="fw-semibold text-secondary">
                            Not Interested
                          </div>

                          <small className="text-muted">
                            Student is not interested
                          </small>
                        </div>
                      </label>
                    </div>

                    <div className="col-md-4">
                      <label
                        htmlFor="followUp"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="followUp"
                          name="status"
                          value="follow_up"
                          className="form-check-input mt-0"
                          required
                        />

                        <div>
                          <div className="fw-semibold text-warning">
                            Follow Up
                          </div>

                          <small className="text-muted">
                            Contact student again
                          </small>
                        </div>
                      </label>
                    </div>

                    <div className="col-md-4">
                      <label
                        htmlFor="hot"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="hot"
                          name="status"
                          value="hot"
                          className="form-check-input mt-0"
                          required
                        />

                        <div>
                          <div className="fw-semibold text-danger">Hot</div>

                          <small className="text-muted">
                            High potential lead
                          </small>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* RESPONSE */}

                <div className="mb-4">
                  <label className="form-label fw-semibold">Response</label>

                  <textarea
                    className="form-control text-capitalize input-uppercase"
                    name="response"
                    placeholder="Enter your response"
                    style={{
                      minHeight: "120px",
                      resize: "vertical",
                    }}
                    required
                  ></textarea>

                  <span className="text-danger small">
                    {error?.response ?? ""}
                  </span>
                </div>

                {/* AMOUNT + DATE */}

                <div className="row">
                  {type === "fees" && (
                    <div className="mb-4 col-md-6">
                      <label className="form-label fw-semibold">Amount</label>

                      <div className="input-group">
                        <span className="input-group-text">₹</span>

                        <input
                          type="text"
                          className="form-control"
                          name="amount"
                          placeholder="Amount"
                          required
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.amount ?? ""}
                      </span>
                    </div>
                  )}

                  <div
                    className={`mb-4 ${
                      type === "fees" ? "col-md-6" : "col-md-12"
                    }`}
                  >
                    <label className="form-label fw-semibold">
                      Next Follow-up Date
                    </label>

                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri ri-calendar-event-line"></i>
                      </span>

                      <input
                        type="date"
                        className="form-control"
                        name="next_followup_date"
                        required
                      />
                    </div>

                    <span className="text-danger small">
                      {error?.next_followup_date ?? ""}
                    </span>
                  </div>
                </div>

                {/* ACTIONS */}

                <div className="d-flex justify-content-end gap-2 pt-2">
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="ri ri-save-line me-1"></i>
                        Submit
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>

            {/* FOOTER */}

            <div className="modal-footer border-0 bg-light px-4 py-3">
              <small className="text-muted">
                <i className="ri ri-information-line me-1"></i>
                Please review the response before submitting.
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* ================================================================
          ADD STUDENT MODAL
      ================================================================= */}

      <div
        className="modal fade"
        id="addStudentModal"
        tabIndex="-1"
        aria-labelledby="addStudentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
          <div className="modal-content border-0 shadow">
            {/* HEADER */}

            <div className="modal-header border-0 px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                  style={{
                    width: "44px",
                    height: "44px",
                  }}
                >
                  <i className="ri ri-user-add-line fs-5 text-primary"></i>
                </div>

                <div>
                  <h5
                    className="modal-title text-primary fw-bold mb-1"
                    id="addStudentModalLabel"
                  >
                    Add Student
                  </h5>

                  <small className="text-muted">
                    Create a new counselor lead
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* BODY */}

            <div className="modal-body px-4">
              <form id="followupForm" onSubmit={createStudent}>
                <input
                  type="hidden"
                  name="counselor_id"
                  value={selectedCounselor}
                />

                {/* ==================================================
                    PERSONAL INFORMATION
                ================================================== */}

                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <i className="ri ri-user-line text-primary"></i>
                    </div>

                    <div>
                      <h6 className="fw-bold mb-0">Personal Information</h6>

                      <small className="text-muted">
                        Basic student details
                      </small>
                    </div>
                  </div>

                  <div className="row g-3">
                    {/* NAME */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Student Name <span className="text-danger">*</span>
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-user-line"></i>
                        </span>

                        <input
                          className="form-control text-capitalize input-capitalize"
                          type="text"
                          name="name"
                          placeholder="Student Name"
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.name ?? ""}
                      </span>
                    </div>

                    {/* FATHER */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Father Name
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-parent-line"></i>
                        </span>

                        <input
                          className="form-control text-capitalize input-uppercase"
                          type="text"
                          name="fathers_name"
                          placeholder="Father Name"
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.fathers_name ?? ""}
                      </span>
                    </div>

                    {/* MOBILE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Mobile No <span className="text-danger">*</span>
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-phone-line"></i>
                        </span>

                        <input
                          className="form-control text-capitalize"
                          type="text"
                          name="mobile"
                          placeholder="Mobile No"
                          minLength={10}
                          maxLength={10}
                          required
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.mobile ?? ""}
                      </span>
                    </div>

                    {/* FOLLOWUP */}

                    {status !== "not_interested" && (
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Next Follow-up Date
                        </label>

                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri ri-calendar-event-line"></i>
                          </span>

                          <input
                            type="date"
                            className="form-control text-capitalize"
                            name="next_followup_date"
                            required={status !== "not_interested"}
                          />
                        </div>

                        <span className="text-danger small">
                          {error?.next_followup_date ?? ""}
                        </span>
                      </div>
                    )}

                    {/* ALTERNATE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Alternate No
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-phone-find-line"></i>
                        </span>

                        <input
                          className="form-control text-capitalize"
                          type="text"
                          name="alternate_no"
                          placeholder="Alternate No"
                          minLength={10}
                          maxLength={10}
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.alternate_no ?? ""}
                      </span>
                    </div>
                  </div>
                </div>

                <hr />

                {/* ==================================================
                    ACADEMIC INFORMATION
                ================================================== */}

                <div className="mb-4 pt-2">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <i className="ri ri-graduation-cap-line text-primary"></i>
                    </div>

                    <div>
                      <h6 className="fw-bold mb-0">Academic Information</h6>

                      <small className="text-muted">
                        Course and education details
                      </small>
                    </div>
                  </div>

                  <div className="row g-3">
                    {/* COURSE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Select Course
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-book-open-line"></i>
                        </span>

                        <select
                          className="form-select text-capitalize"
                          id="course_id"
                          name="course_id"
                        >
                          <option value="" disabled>
                            Select Course
                          </option>

                          {courses.map((course) => (
                            <option key={course.id} value={course.id}>
                              {course.title}
                            </option>
                          ))}
                        </select>
                      </div>

                      <span className="text-danger small">
                        {error?.course_id ?? ""}
                      </span>
                    </div>

                    {/* EDUCATION */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        School Level
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-school-line"></i>
                        </span>

                        <select
                          className="form-select text-capitalize"
                          name="edu_level"
                        >
                          <option value="" disabled>
                            Select Education
                          </option>

                          <option value="9th">9th</option>

                          <option value="10th">10th</option>

                          <option value="11th">11th</option>

                          <option value="12th">12th</option>
                        </select>
                      </div>

                      <span className="text-danger small">
                        {error?.edu_level ?? ""}
                      </span>
                    </div>
                  </div>
                </div>

                <hr />

                {/* ==================================================
                    SOURCE
                ================================================== */}

                <div className="mb-4 pt-2">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <i className="ri ri-megaphone-line text-primary"></i>
                    </div>

                    <div>
                      <h6 className="fw-bold mb-0">Lead Source</h6>

                      <small className="text-muted">
                        Marketing source information
                      </small>
                    </div>
                  </div>

                  <div className="row g-3">
                    {/* SOURCE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Source Name <span className="text-danger">*</span>
                      </label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-share-forward-line"></i>
                        </span>

                        <select
                          className="form-select text-capitalize"
                          name="source_id"
                          required
                        >
                          <option value="" disabled>
                            Select Source
                          </option>

                          {source?.data?.map((sch) => (
                            <option key={sch.id} value={sch.id}>
                              {sch.source_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <span className="text-danger small">
                        {error?.source_id ?? ""}
                      </span>
                    </div>
                  </div>
                </div>

                <hr />

                {/* ==================================================
                    LOCATION
                ================================================== */}

                <div className="mb-4 pt-2">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <i className="ri ri-map-pin-line text-primary"></i>
                    </div>

                    <div>
                      <h6 className="fw-bold mb-0">Location Details</h6>

                      <small className="text-muted">
                        Student address information
                      </small>
                    </div>
                  </div>

                  <div className="row g-3">
                    {/* STATE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">State</label>

                      <select
                        className="form-select text-capitalize"
                        name="state"
                        onChange={(e) => getdistrict(e.target.value)}
                      >
                        <option value="" disabled>
                          Select State
                        </option>

                        {allStates?.map((state) => (
                          <option key={state.id} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>

                      <span className="text-danger small">
                        {error?.state ?? ""}
                      </span>
                    </div>

                    {/* DISTRICT */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">District</label>

                      <select
                        className="form-select text-capitalize"
                        name="district"
                        onChange={(e) => getblock(e.target.value)}
                      >
                        <option value="" disabled>
                          Select District
                        </option>

                        {allDistricts?.map((district) => (
                          <option key={district.id} value={district.name}>
                            {district.name}
                          </option>
                        ))}
                      </select>

                      <span className="text-danger small">
                        {error?.district ?? ""}
                      </span>
                    </div>

                    {/* BLOCK */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Block</label>

                      <select
                        className="form-select text-capitalize"
                        name="block"
                      >
                        {allBlock?.map((blk) => (
                          <option key={blk.id} value={blk.name}>
                            {blk.name}
                          </option>
                        ))}
                      </select>

                      <span className="text-danger small">
                        {error?.block ?? ""}
                      </span>
                    </div>

                    {/* VILLAGE */}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Village</label>

                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ri ri-community-line"></i>
                        </span>

                        <input
                          className="form-control text-capitalize input-uppercase"
                          type="text"
                          name="village"
                          placeholder="Village"
                        />
                      </div>

                      <span className="text-danger small">
                        {error?.village ?? ""}
                      </span>
                    </div>

                    {/* ADDRESS */}

                    <div className="col-12">
                      <label className="form-label fw-semibold">Address</label>

                      <textarea
                        className="form-control text-capitalize input-uppercase"
                        name="address"
                        placeholder="Enter complete address"
                        rows="3"
                      ></textarea>

                      <span className="text-danger small">
                        {error?.address ?? ""}
                      </span>
                    </div>
                  </div>
                </div>

                <hr />

                {/* ==================================================
                    STATUS
                ================================================== */}

                <div className="mb-4 pt-2">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded bg-label-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <i className="ri ri-price-tag-3-line text-primary"></i>
                    </div>

                    <div>
                      <h6 className="fw-bold mb-0">Initial Lead Status</h6>

                      <small className="text-muted">
                        Select the current student interest level
                      </small>
                    </div>
                  </div>

                  <div className="row g-2">
                    {/* NOT INTERESTED */}

                    <div className="col-md-4">
                      <label
                        htmlFor="notInterestedStudent"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="notInterestedStudent"
                          name="status"
                          value="not_interested"
                          className="form-check-input mt-0"
                          onChange={(e) => setStatus(e.target.value)}
                          required
                        />

                        <div>
                          <div className="fw-semibold text-secondary">
                            Not Interested
                          </div>

                          <small className="text-muted">
                            No further follow-up
                          </small>
                        </div>
                      </label>
                    </div>

                    {/* FOLLOW UP */}

                    <div className="col-md-4">
                      <label
                        htmlFor="followUpStudent"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="followUpStudent"
                          name="status"
                          value="follow_up"
                          className="form-check-input mt-0"
                          onChange={(e) => setStatus(e.target.value)}
                          required
                        />

                        <div>
                          <div className="fw-semibold text-warning">
                            Follow Up
                          </div>

                          <small className="text-muted">
                            Continue conversation
                          </small>
                        </div>
                      </label>
                    </div>

                    {/* HOT */}

                    <div className="col-md-4">
                      <label
                        htmlFor="hotStudent"
                        className="border rounded p-3 d-flex align-items-center gap-2 w-100"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="hotStudent"
                          name="status"
                          value="hot"
                          className="form-check-input mt-0"
                          onChange={(e) => setStatus(e.target.value)}
                          required
                        />

                        <div>
                          <div className="fw-semibold text-danger">Hot</div>

                          <small className="text-muted">
                            High potential student
                          </small>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* ==================================================
                    RESPONSE
                ================================================== */}

                <div className="mb-4">
                  <label className="form-label fw-semibold">Response</label>

                  <textarea
                    className="form-control text-capitalize input-uppercase"
                    name="response"
                    placeholder="Enter your response"
                    style={{
                      minHeight: "120px",
                      resize: "vertical",
                    }}
                    required
                  ></textarea>

                  <span className="text-danger small">
                    {error?.response ?? ""}
                  </span>
                </div>

                {/* ==================================================
                    SUBMIT
                ================================================== */}

                <div className="d-flex justify-content-end gap-2 pt-2 pb-2">
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="ri ri-user-add-line me-1"></i>
                        Create Student
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CounselorCall;
